import React, { useState, useEffect, useRef } from "react";
import helpIcon from "../../assets/svg/help.svg";
import bellIcon from "../../assets/svg/bell.svg";
import settingsIcon from "../../assets/svg/settings.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { getOrgLogoApi, getProfileDetailsApi, getOrgListApi } from "./common-api";
import ReportAnIssueModal from "../common/report-an-issue-modal";
import issue from "../../assets/svg/issue.svg";
import ProfilePopup from "./ProfilePopup";
import Component from "../../assets/png/component.png";
import DownloadApplication from "./download-application.jsx";

export const Navbar = ({ pageTitle }) => {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const googlePlayStore = process.env.REACT_APP_GOOGLE_PLAY_STORE;
  const applePlayStore = process.env.REACT_APP_APPLE_STORE;
  const navigate = useNavigate();
  const location = useLocation();
  const [profileDetail, setProfileDetail] = useState({});
  const [showComplaintModule, setShowComplaintModule] = useState(false);

  const [hovered, setHovered] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [orgLogo, setOrgLogo] = useState("");
  const [orgName, setOrgName] = useState("");
  const [firstLetter, setFirstLetter] = useState("");

  useEffect(() => {
    getOrgList();
    getOrgLogo();
    getProfileDetails();
  }, []);
  const [orgList, setOrgList] = useState([]);
  const getOrgList = async () => {
    console.log("Getting org list");
    const response = await getOrgListApi();
    console.log(response.data);
    if (response.status === 200) {
      console.log(response.data.orgs);
      if (response.data.success === true) {
        setOrgList(response.data.orgs ?? []);
      }
    }
  };
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        setOrgLogo(response.image ?? "");
        setOrgName(response.org_name ?? "....");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getProfileDetails = async () => {
    try {
      const response = await getProfileDetailsApi();

      if (!response) {
        console.error("No response received from API");
        return;
      }

      if (response.status === 200 && response.data?.success) {
        setProfileDetail(response.data.user);
        setFirstLetter(response.data.user?.first_name ? response.data.user.first_name.charAt(0) : "");
      }
    } catch (err) {
      console.error("Error in getProfileDetails:", err);
    }
  };

  return (
    <>
      {showComplaintModule && (
        <ReportAnIssueModal
          onSuccess={() => {
            setShowComplaintModule(false);
          }}
          onCancel={() => {
            setShowComplaintModule(false);
          }}
        />
      )}
      {showPopup && <ProfilePopup orgList={orgList} profileDetail={profileDetail} onClose={() => setShowPopup(false)} orgLogo={orgLogo} orgName={orgName} callProfileFunc={getProfileDetails} />}
      <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom bg-white" style={{ height: "56px" }}>
        <div>{pageTitle && <h6 className="m-0 fw-semibold text-secondary">{pageTitle}</h6>}</div>
        <div className="d-flex align-items-center gap-3">
          <div>
            <img
              src={Component}
              style={{ height: "40px", cursor: "pointer" }}
              alt="Home Icon"
              onClick={() => {
                window.open(accountsUrl, "_blank", "noopener,noreferrer");
              }}
            />
          </div>
          <DownloadApplication name={"Transport"} googlePlayStore={googlePlayStore} applePlayStore={applePlayStore} />
          <div className="right_divs">
            <button
              onClick={() => {
                setShowComplaintModule(true);
              }}
              type="button"
              className="right_divs px-2"
              style={{
                width: "152px",
                height: "36px",
                display: "flex",
                alignItems: "center",
                columnGap: "8px",
                fontSize: "13px",
                border: "none",
                borderRadius: "12px",
                backgroundColor: "#F8F8F8",
                color: "#172B4D",
                fontWeight: "500",
              }}
            >
              <img src={issue} alt="issue" srcSet="" style={{ width: "20px", height: "20px", cursor: "pointer" }} />
              <span>Report an issue</span>
            </button>
          </div>
          <div
            className="px-2"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/help");
            }}
          >
            <img src={helpIcon} alt="help" style={{ width: "20px", height: "20px", cursor: "pointer" }} />
          </div>
          <div
            onClick={() => {
              setShowPopup(!showPopup);
            }}
            style={{ cursor: "pointer", paddingRight: "16px" }}
          >
            {profileDetail.profile_image != null && profileDetail.profile_image !== "" && (
              <img
                src={profileDetail.profile_image}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "100px",
                }}
                alt="Profile"
              />
            )}
            {(profileDetail.profile_image == null || profileDetail.profile_image === "") && (
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#7525B1",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#FFFFFF",
                  }}
                >
                  {firstLetter}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
